const strings = {
    sv: {
        'Zoezi Developer Portal': 'Zoezi Utvecklarportal',
        'Add developer': 'Lägg till utvecklare',
        'E-mail': 'E-post',
        'Name': 'Namn',
        'First name': 'Förnamn',
        'Last name': 'Efternamn',
        'Cancel': 'Avbryt',
        'Save': 'Spara',
        'My addons': 'Mina tillval',
        'Usage': 'Användning',
        'Sales': 'Försäljning',
        'Settings': 'Inställningar',
        'Log out': 'Logga ut',
        'Permissions the addon will be granted': 'Behörigheter som tillvalet kommer ges',
        'E-mail to support': 'E-post till support',
        'Language': 'Språk',
        'Remove': 'Ta bort',
        'SSH keys': 'SSH-nycklar',
        'SSH public key': 'Publik SSH-nyckel',
        'Review': 'Granska',
        'Add SSH key': 'Lägg till SSH-nyckel',
        'No SSH keys found': 'Inga SSH-nycklar hittades',
        'Cancel': 'Avbryt',
        'Error': 'Fel',
        'Could not add SSH key. Make sure the key length is enough. For RSA, minimum length is 3071 chars.': 'Kunde inte lägga till SSH-nyckel. Se till att nyckellängden är tillräcklig. För RSA är det 3071 tecken.',
        'Could not remove SSH key': 'Kunde inte ta bort SSH-nyckel',
        'Enable Git': 'Aktivera Git',
        'Could not enable Git': 'Kunde inte aktivera Git',
        'Git is enabled': 'Git är aktiverat',
        'New password': 'Nytt lösenord',
        'Change password and log in': 'Byt lösenord och logga in',

        // Sidebar sections
        'Info': 'Info',
        'Development': 'Utveckling',
        'Branch packets': 'Branschpaket',

        // Info sidebar items
        'Store information': 'Butiksinformation',
        'Feature description': 'Funktionsbeskrivning',
        'Price': 'Pris',
        'Status': 'Status',

        // Store information form
        'Enter addon name': 'Skriv in namnet på tillvalet',
        'Send e-mail here when addon starts': 'Skicka e-post hit vid start av tillval',
        'Required base functionality': 'Grundfunktionalitet som tillvalet kräver',
        'Belongs to category': 'Tillhör kategori',
        'Enabled by default in branch packets': 'Aktiveras från start i branschpaket',
        'Recommended for branch packets': 'Rekommenderas för branschpaket',
        'Description': 'Beskrivning',
        'Description of the addon that customers will see': 'Beskrivning av tillvalet som kunder kommer se',
        'Startup information': 'Uppstartsinformation',
        'Information shown to the customer when addon is added': 'Information som visas för kunden när tillvalet läggs till',
        'Image': 'Bild',
        'Screenshots': 'Skärmbilder',
        'Remove addon': 'Ta bort tillvalet',

        // Price form
        'Start fee': 'Startkostnad',
        'Price per month': 'Pris per månad',
        'Charge per': 'Ta betalt per',
        'Usage name': 'Namn på användning',
        'Example: invoice,invoices': 'Exempel: faktura,fakturor',
        'Free': 'Antal fria',
        'per month': 'per månad',
        'Price per': 'Pris per',
        'Percent per': 'Procent per',
        'New price rule': 'Ny prisregel',
        'Available for all Zoezi customers': 'Tillgängligt för samtliga Zoezi-kunder',
        'New availability rule': 'Ny tillgänglighetsregel',

        // Settings form
        'Select version': 'Välj version',
        'API key': 'API-nyckel',
        'Each customer gets their own API key': 'Varje kund får egen API-nyckel',
        'Webhook key': 'Webhook-nyckel',
        'Test system': 'Testsystem',
        'In the test system you can log in and test the addon. Username for login:': 'I testsystemet går det att logga in och testa tillvalet. Användarnamn för inloggning:',
        'To start the addon, go to the Addon Store.': 'För att starta tillvalet, gå till Tillvalsbutiken.',
        'Go to test system': 'Gå till testsystemet',

        // Webhooks
        'Use built-in function': 'Använd inbyggd funktion',
        'Function': 'Funktion',
        'Event filter': 'Händelsefilter',

        // Components
        'Select component': 'Välj komponent',
        'Use in other components as:': 'Använd i andra komponenter som:',
        'Select component type': 'Välj komponenttyp',
        'Remove component': 'Ta bort komponenten',
        'Dependencies': 'Dependencies',
        'Compilation': 'Kompilering',

        // Functions
        'Select function': 'Välj funktion',
        'Max execution time': 'Maximal körtid',
        'Code': 'Kod',
        'Test': 'Test',
        'Logs': 'Loggar',
        'Log': 'Logg',
        'New function': 'Ny funktion',

        // Dialog titles
        'Prices': 'Priser',
        'Availability': 'Tillgänglighet',
        'Setting': 'Inställning',
        'Permission': 'Behörighet',
        'Widget': 'Widget',
        'Mailing handler': 'Utskickshanterare',

        // Review section
        'Write any comment to Zoezi reviewers': 'Skriv eventuell kommentar till Zoezi:s granskare',
        'Submit for review': 'Skicka in för granskning',
        'Cancel review': 'Avbryt granskning',
        'If rejecting, provide reason why the addon cannot be approved': 'Vid avslag, ange orsak till varför tillvalet inte kan godkännas',
        'Approve': 'Godkänn',
        'Reject': 'Avslå',

        // Footer
        'API documentation': 'API-dokumentation',
        'Addon added': 'Tillvalet tillagt',
        'Not logged in on test system': 'Inte inloggad på testsystemet',
        'Hotpatch': 'Hotpatcha',

        // New buttons
        'New setting': 'Ny inställning',
        'New permission': 'Ny behörighet',
        'Initialize git for this addon': 'Initiera git för detta tillval',
        'New widget': 'Ny widget',
        'New webhook': 'Ny webhook',
        'New mailing handler': 'Ny utskickshanterare',
        'New component': 'Ny komponent',
        'New API': 'Nytt API',

        // Notifications
        'Notifications': 'Notifieringar',
        'Notification Settings': 'Notifieringsinställningar',
        'Notification email(s)': 'E-postadress(er) för notifieringar',
        'Comma-separated. Leave empty to use addon support email': 'Kommaseparerade. Lämna tomt för att använda tillvalets support-e-post',
        'Notify on': 'Notifiera vid',
        'Errors': 'Fel',
        'Warnings': 'Varningar',
        'Info': 'Info',
        'Frequency': 'Frekvens',
        'Smart': 'Smart',
        'Backoff after repeated errors: 1h, 4h, then daily': 'Avtar vid upprepade fel: 1h, 4h, sedan dagligen',
        'Always': 'Alltid',
        'Max 1 per hour per error type': 'Max 1 per timme per feltyp',
        'Disabled': 'Inaktiverad',
        'No email notifications': 'Inga e-postnotifieringar',
        'Send test notification': 'Skicka testnotifiering',
        'Test notification sent to': 'Testnotifiering skickad till',
        'Failed to send test notification': 'Kunde inte skicka testnotifiering',
        'Invalid email address': 'Ogiltig e-postadress',
        'Invalid email format': 'Ogiltigt e-postformat',
        'Save changes before testing': 'Spara ändringar innan du testar',
        'Trigger test error': 'Skapa testfel',
        'Test error created': 'Testfel skapat',
        'Failed to create test error': 'Kunde inte skapa testfel',
        'These settings apply to the addon as a whole and take effect immediately (no review required).': 'Dessa inställningar gäller för hela tillvalet och träder i kraft omedelbart (ingen granskning krävs).',
        'Save notification settings': 'Spara notifieringsinställningar',
        'Save notification settings before testing': 'Spara notifieringsinställningar innan du testar',
        'Notification settings saved': 'Notifieringsinställningar sparade',
        'Failed to save notification settings': 'Kunde inte spara notifieringsinställningar',

        // Compilation
        'Compile': 'Kompilera',
        'Compilation complete': 'Kompilering klar',
        'File size': 'Filstorlek',
        'Compilation failed': 'Kompilering misslyckades',

        // Function testing
        'Test function': 'Testa funktionen',
        'Ran without errors': 'Kördes utan fel',
        'Ran with errors': 'Kördes med fel',
        'Fetch logs': 'Hämta loggar',

        // Validation errors
        'There are unsaved changes': 'Det finns osparade ändringar',
        'Addon description is missing': 'Beskrivning av tillvalet saknas',
        'Support e-mail is missing': 'E-postadress till support saknas',
        'Product category is missing': 'Produktkategori saknas',
        'Addon is missing an image': 'Tillvalet saknar en bild',

        // Misc
        'by': 'av',
        'Search': 'Sök',
        'Copy': 'Kopiera',

        // Main addon list
        'Create new addon': 'Skapa nytt tillval',
        'New addon': 'Nytt tillval',
        'In development': 'Under utveckling',
        'Under review': 'Granskas',
        'Published': 'Publicerad',
        'Could not add new addon': 'Kunde inte lägga till nytt tillval',
        'Do you really want to remove the development version of the addon?': 'Vill du verkligen ta bort utvecklingsversionen av tillvalet?',
        'Create new version': 'Skapa ny version',

        // Preview/Feature description
        'Describe for customers how the addon works': 'Beskriv för kunderna hur tillvalet fungerar',
        'This will be shown to all customers in their system when they want to read about the addon, and also on our website. Briefly describe what the addon is for and how it works for staff and members.': 'Detta kommer visas för alla kunder i deras system när de vill läsa om tillvalet, och även på vår hemsida. Beskriv kortfattat vad tillvalet är till för och hur det fungerar för personal och medlemmar.',
        'Back': 'Tillbaka',
        'Next': 'Nästa',
        'Add page': 'Lägg till sida',
        'Add': 'Lägg till',
        'Remove page': 'Ta bort sida',
        'Possibilities with': 'Möjligheter med',
        'How it works for customers': 'Så fungerar det för kunderna',
        'How it works for staff': 'Så fungerar det för personalen',
        'Heading': 'Rubrik',
        'Information': 'Information',
        'Functionality': 'Funktionalitet',
        'Item': 'Punkt',
        'month': 'mån',
        'Enter name': 'Skriv in namnet',

        // Validation messages
        'Value is required': 'Värdet måste fyllas i',
        'Invalid URL': 'Ingen giltig webbadress',
        'Invalid decimal number': 'Inget giltigt decimaltal',

        // Type options
        'Type': 'Typ',
        'Text': 'Text',
        'Number': 'Tal',
        'Checkbox': 'Kryssruta',

        // Confirm dialogs
        'Confirm': 'Bekräfta',
        'Are you sure?': 'Är du säker?',
        'Continue': 'Fortsätt',
        'Do you really want to remove the function?': 'Vill du verkligen ta bort funktionen?',
        'Do you really want to remove the component?': 'Vill du verkligen ta bort komponenten?',
        'Do you really want to remove the webhook?': 'Vill du verkligen ta bort webhooket?',
        'Do you really want to remove the widget?': 'Vill du verkligen ta bort widgeten?',
        'Do you really want to remove the mailing handler?': 'Vill du verkligen ta bort utskickshanteraren?',
        'Do you really want to remove the API?': 'Vill du verkligen ta bort API:et?',
        'Do you really want to remove the setting?': 'Vill du verkligen ta bort inställningen?',
        'Do you really want to remove the permission?': 'Vill du verkligen ta bort behörigheten?',
        'Do you really want to remove the price rule?': 'Vill du verkligen ta bort prisregeln?',
        'Do you really want to remove the availability rule?': 'Vill du verkligen ta bort tillgänglighetsregeln?',
        'Do you really want to remove the addon?': 'Vill du verkligen ta bort tillvalet?',

        // Table headers
        'Shown where?': 'Visas var?',
        'Chain': 'Kedja',
        'Free transactions per month': 'Antal fria transaktioner per månad',
        'Price per transaction': 'Pris per transaktion',
        'Percent per transaction': 'Procent per transaktion',

        // Field labels
        'For all others': 'För alla andra',
        'Invocation type': 'Anropas hur?',
        'Component': 'Komponent',
        'Permission required to show widget': 'Behörighet som krävs för att visa widgeten',
        'Title': 'Titel',
        'Field name (id)': 'Namn på fält (id)',
        'Required': 'Obligatorisk',
        'Long text': 'Längre text',
        'Date': 'Datum',
        'Time': 'Tid',
        'Date and time': 'Datum och tid',
        'Default value': 'Defaultvärde',
        'Must start with /': 'Måste börja på /',
        'Use {name} for a value from the path, e.g. /booking/{id}. Path parameters must be Number or String and are always required': 'Använd {name} för ett värde från sökvägen, t.ex. /booking/{id}. Sökvägsparametrar måste vara Tal eller Sträng och är alltid obligatoriska',
        'Method': 'Metod',
        'Path': 'Sökväg',
        'Logged in user required': 'Inloggad användare krävs',
        'Permission required to call': 'Behörighet som krävs för att anropa',
        'Parameters': 'Parametrar',
        'New parameter': 'Ny parameter',
        'Parameter name': 'Namn på parameter',
        'String': 'Sträng',
        'List of numbers': 'Lista med tal',
        'Template': 'Mall',

        // Webhook actions
        'Addition': 'Tillägg',
        'Update': 'Uppdatering',
        'Deletion': 'Borttagning',

        // Review page
        'Developer': 'Utvecklare',
        'Last modified': 'Senast ändrad',

        // Development sidebar items
        'APIs': 'API:er',
        'Functions': 'Funktioner',
        'Components': 'Komponenter',
        'Mailing handlers': 'Utskickshanterare',
        'Webhooks': 'Webhooks',
        'Widgets': 'Widgets',

        // Health page
        'Health': 'Hälsa',
        'Overview of errors and events across all your addons': 'Översikt över fel och händelser för alla dina tillval',
        'Loading...': 'Laddar...',
        'No addons found': 'Inga tillval hittades',
        'No addons match filter': 'Inga tillval matchar filtret',
        'All good!': 'Allt väl!',
        'No errors to report': 'Inga fel att rapportera',
        'Show': 'Visa',
        'With errors': 'Med fel',
        'Without errors': 'Utan fel',
        'of': 'av',
        'Supplier': 'Leverantör',
        'All suppliers': 'Alla leverantörer',
        'My suppliers': 'Mina leverantörer',
        'new': 'ny',
        'new_plural': 'nya',
        'View events': 'Visa händelser',

        // Event log
        'Event Log': 'Händelselogg',
        'Track errors and events from webhooks, functions, and custom reports.': 'Spåra fel och händelser från webhooks, funktioner och egenrapporterade händelser.',
        'Time': 'Tid',
        'Level': 'Nivå',
        'Source': 'Källa',
        'Message': 'Meddelande',
        'Events': 'Händelser',
        'Domain': 'Domän',
        'Domains': 'Domäner',
        'State': 'Status',
        'Change state': 'Ändra status',
        'Delete': 'Ta bort',
        'Event Details': 'Händelsedetaljer',
        'Close': 'Stäng',
        'Mark Acknowledged': 'Markera bekräftad',
        'Mark Resolved': 'Markera löst',
        'Change State': 'Ändra status',
        'Change State for': 'Ändra status för',
        'events': 'händelser',
        'Delete events': 'Ta bort händelser',
        'Are you sure you want to delete': 'Är du säker på att du vill ta bort',
        'This cannot be undone.': 'Detta kan inte ångras.',
        'Event not found': 'Händelsen hittades inte',
        'The event may have been deleted.': 'Händelsen kan ha tagits bort.',
        'last': 'senast',
        'Context': 'Kontext',
        'Go to code': 'Gå till kod',

        // Event states
        'acknowledged': 'bekräftad',
        'resolved': 'löst',

        // Event levels
        'error': 'fel',
        'warning': 'varning',
        'info': 'info',

        // Welcome page
        'Welcome to Zoezi Developer Portal for suppliers': 'Välkommen till Zoezis utvecklarportal för leverantörer',
        'Here you as a supplier can manage addons. Start by clicking Create new addon below and fill in the required information. Then submit the addon for review.': 'Här kan du som leverantör hantera tillval. Börja med att trycka på Skapa nytt tillval här nedan och fyll sedan i de uppgifter som behövs. Därefter skickar du in tillvalet för granskning.',
        'Once the addon is reviewed and approved you can follow sales and usage on this page.': 'När tillvalet väl är granskat och klart kan du följa försäljning och användning på den här sidan.',
        'For more information on how to build an addon': 'För mer information om hur man tillverkar ett tillval',
        'follow this link': 'följ den här länken',

        // Package list
        'Create new branch package': 'Skapa nytt branschpaket',

        // Set password
        'Password': 'Lösenord',
        'Confirm password': 'Bekräfta lösenord',
        'Set password and log in': 'Sätt lösenord och logga in',

        // Review addons
        'Select status': 'Välj status',

        // Sales
        'Select addon': 'Välj tillval',
        'addons selected': 'tillval valda',
        'selected': 'valda',
        'All addons': 'Alla tillval',
        'Select revenue type': 'Välj intäkt',
        'Select time period': 'Välj tid',
        'Show sales from date': 'Visa försäljning från datum',
        'Show sales to date': 'Visa försäljning till datum',
        'Transaction': 'Transaktion',
        'Monthly cost': 'Månadskostnad',
        'Days': 'Dagar',
        'Months': 'Månader',

        // Stats
        'Show users from date': 'Visa användare från datum',
        'Show users to date': 'Visa användare till datum',
        'Systems with specific addon': 'System med visst tillval',
        'Number of systems': 'Antal system',
        'Number of active addon users': 'Antal som har tillvalet igång',

        // Package tabs
        'Summary': 'Sammanfattning',
        'Enabled & recommended': 'Aktiverat & rekommenderat',
        'Greetings': 'Hälsningar',
        'Welcome page': 'Välkomstsida',
        'Getting started': 'Kom igång',
        'Categories': 'Kategorier',
        'Packages & prices': 'Paket & priser',
        'Enabled from start': 'Aktiverat från start',
        'Recommended': 'Rekommenderas',
        'Greetings from customer advisor or other person': 'Hälsningar från kundrådgivare eller annan person',
        'The content added here is shown in all customer systems belonging to this branch package. If "Customer advisor" is selected, the image and information will be automatically fetched from the person responsible for the system in Runningsystems ("Responsible" on the customer card).': 'Innehållet som läggs in här visas i alla kundsystem som tillhör detta branschpaket. Väljs "Kundrådgivare" kommer bild och information automatiskt hämtas från den som är ansvarig för systemet i Runningsystems ("Ansvarig" på kundkortet).',
        'The Getting started page helps new customers set up the system smoothly. On this page you can customize which steps are shown in systems belonging to this branch package. Getting started steps that only depend on enabled features will always be shown when applicable.': 'Kom igång-sidan är till för att hjälpa nya kunder sätta upp systemet på ett smidigt sätt. På denna sida kan du anpassa vilka steg som ska visas i systemen som tillhör detta branschpaket. Kom igång-steg som endast beror på aktiverade funktioner kommer dock alltid visas om det är aktuellt.',
        'Change': 'Ändra',
        'The package must have a name': 'Paketet måste ges ett namn',

        // Package getting started tasks
        'All settings made on this page will be overwritten and cannot be undone': 'Alla inställningar som gjorts på denna sida kommer skrivas över och kan inte ångras',
        'Copy getting started steps from branch package': 'Kopiera kom igång-stegen från branschpaket',
        'Search card or guide ID': 'Sök kort eller guide-ID',
        'Order': 'Ordning',
        'Getting started step': 'Kom igång-steg',
        'Contains guides': 'Innehåller guider',
        'Show in Getting started': 'Visa i Kom igång',
        'Select package': 'Välj paket',

        // Package greeting edit card
        'New section': 'Nytt stycke',
        'Remove section': 'Ta bort stycke',
        'Add new section': 'Lägg till nytt stycke',
        'Remove greeting': 'Ta bort hälsning',
        'Show greeting on': 'Visa hälsningen på',
        'Current plan page': 'Aktuell plan-sidan',
        'Offer page': 'Erbjudandesidan',
        'Getting started page': 'Kom igång-sidan',
        'Active': 'Aktiv',
        'Hi! My name is {firstname} and I am your personal contact at Zoezi': 'Hej! Jag heter {firstname} och jag är er personliga kontakt på Zoezi',
        'From': 'Från',
        'Customer advisor': 'Kundrådgivare',
        'Other': 'Annan',
        'Upload image (Optional)': 'Ladda upp bild (Valfritt)',

        // Package greeting list
        'Add new greeting': 'Lägg till ny hälsning',
        'In test system': 'I testsystem',
        'In active system': 'I aktivt system',

        // Show addon component
        'Git is set up for this addon.': 'Git är uppsatt för detta tillval.',
        'To check out:': 'För att checka ut:',
        'Template for widget': 'Mall för widget',
        'Template for webhooks': 'Mall för webhooks',
        'Template for API': 'Mall för API',
        'Template for mailing': 'Mall för utskick',
        'Vue 2 (website and admin)': 'Vue 2 (hemsida och admin)',
        'Vue 3 (admin)': 'Vue 3 (admin)',
        'For website and admin page': 'För hemsida och adminsida',
        'For admin page. Faster, more efficient and more features': 'För adminsida. Snabbare, effektivare och fler möjligheter',
        'The addon must have a name': 'Tillvalet måste ges ett namn',
        'Invalid system address': 'Ingen giltig systemadress',
        'Something went wrong during compilation': 'Något gick fel vid kompileringen',
        'Something went wrong. Try again or contact support.': 'Något gick fel. Försök igen eller kontakta supporten.',
        'Deprecated {0}': 'Stöds ej efter {0}',
        'Support ended {0}': 'Stöd avslutades {0}',
        'This function uses a runtime that is no longer supported ({0}).': 'Denna funktion använder en språkversion som inte längre stöds ({0}).',
        'This function uses a runtime that will stop accepting changes ({0}). Switch to a supported runtime before then.': 'Denna funktion använder en språkversion som slutar ta emot ändringar ({0}). Byt till en språkversion som stöds innan dess.',
        'Another {0} function(s) also use runtimes that are no longer supported.': 'Ytterligare {0} funktion(er) använder språkversioner som inte längre stöds.',
        '{0} function(s) use runtimes that are no longer supported.': '{0} funktion(er) använder språkversioner som inte längre stöds.',
        '{0} changed function(s) use runtimes that are no longer supported.': '{0} ändrad(e) funktion(er) använder språkversioner som inte längre stöds.',
        'Switch them to a supported runtime to save. The addon keeps working in the meantime.': 'Byt till en språkversion som stöds för att kunna spara. Tillvalet fortsätter att fungera under tiden.',
        'They must be switched to a supported runtime before the addon can be submitted for review.': 'De måste byta till en språkversion som stöds innan tillvalet kan skickas för granskning.',
        'The addon keeps working, and other functions can still be changed, but this one must switch to a supported runtime before it can be changed.': 'Tillvalet fortsätter att fungera och andra funktioner går fortfarande att ändra, men den här funktionen måste byta till en språkversion som stöds innan den kan ändras.',

        // Widget types
        'Staff dashboard': 'Personaldashboard',
        'Customer card': 'Kundkort',
        'Staff card': 'Personalkort',
        'General': 'Generell',
        'Economy': 'Ekonomi',
        'Report': 'Rapport',
        'Built-in function': 'Inbyggd funktion',
        'External URL': 'Extern URL',

        // Categories
        'Booking': 'Bokning',
        'Economy overview': 'Koll på ekonomin',
        'Customer management': 'Kundhantering',
        'Your offer': 'Ert erbjudande',
        'On site': 'På plats i lokalen',
        'Payments': 'Ta betalt',
        'Public facing': 'Ansiktet utåt',
        'Staff daily tasks': 'Vardag för personalen',

        // Register component
        'Log in or register new account': 'Logga in eller registrera nytt konto',
        'Log in': 'Logga in',
        'Register new supplier': 'Registrera ny leverantör',
        'Email or username': 'E-post eller användarnamn',
        'Organization number': 'Organisationsnummer',
        'Company name': 'Företagsnamn',
        'Company email': 'E-post till företag',
        'Read the terms for Zoezi Developer Portal': 'Läs villkoren för Zoezi Utvecklarportal',
        'Accept terms': 'Acceptera villkoren',
        'Register': 'Registrera',
        'Forgot password?': 'Glömt lösenord?',
        'Registration almost complete': 'Registrering nästan klar',
        'Check your inbox to continue the registration.': 'Kolla i din inkorg för att fortsätta registreringen.',
        'Reset password': 'Återställ lösenord',
        'Send reset link': 'Skicka återställningslänk',
        'Terms for Zoezi Developer Portal': 'Villkor för Zoezi Utvecklarportal',
        'Could not load portal data. Try again later or contact support.': 'Kunde inte ladda portalens data. Försök igen senare eller kontakta support.'
    },
    // For English, most strings are the same, so they aren't added here
    en: {
        'new_plural': 'new'
    }
}

class TranslationApi {
    translate(x) { // Accessible as $translate or window.$translate
        let language = this.$root?.language || 'sv';
        return strings[language][x] || x;
    }

    setLanguage(language) {
        this.$root.language = language;
        try {
            window.localStorage.setItem('zoeziLanguage', language)
        }
        catch {
            // pass
        }
    }

    setVueRoot($root) {
        this.$root = $root;
        try {
            let language = window.localStorage.getItem('zoeziLanguage')
            if (language) {
                this.$root.language = language;
            }
        }
        catch {
            // pass
        }

        $root.$watch('language', (newValue, oldValue) => {
            if (newValue && newValue != oldValue) {
                console.log('Changing language in watch')
                this.setLanguage(newValue);
            }
        })
    }

    constructor(Vue) {
        this.translations = {};
        this.language = 'sv';
        Vue.prototype.$translations = this;
        Vue.prototype.$translate = (x) => this.translate(x)
        Vue.filter('translate', (x) => this.translate(x));
        window.$translate = (x) => this.translate(x);
    }
}

export default {
    install(Vue) {
        new TranslationApi(Vue)
    }
}
